import { DISCLOSURES, VerificationNames } from "shared/types";
import {
  CreditCard01,
  FaceID,
  Home02,
  Logout01,
  Shield02,
  User03,
  Wallet02
} from "untitledui-js-base";
import PetsIcon from "../../../../shared/icons/pets.svg?react";

export const VERIFICATIONS_ORDER = [
  VerificationNames.RentalApplication,
  VerificationNames.IdentityVerification,
  VerificationNames.VerifiedIncomeVerification,
  VerificationNames.IncomeVerification,
  VerificationNames.CombinedIncome,
  VerificationNames.HousingHistory,
  VerificationNames.CreditReport,
  VerificationNames.CriminalReport,
  VerificationNames.CanadianCriminalReport,
  VerificationNames.EvictionReport,
  VerificationNames.PetScreeningReport
];

export const VERIFICATION_ICON = {
  [VerificationNames.RentalApplication]: User03,
  [VerificationNames.IdentityVerification]: FaceID,
  [VerificationNames.VerifiedIncomeVerification]: Wallet02,
  [VerificationNames.IncomeVerification]: Wallet02,
  [VerificationNames.HousingHistory]: Home02,
  [VerificationNames.CreditReport]: CreditCard01,
  [VerificationNames.EvictionReport]: Logout01,
  [VerificationNames.CriminalReport]: Shield02,
  [VerificationNames.CanadianCriminalReport]: Shield02,
  [VerificationNames.PetScreeningReport]: PetsIcon
};

export const HIDDEN_VERIFICATIONS = [
  ...DISCLOSURES,
  VerificationNames.RentalVerification
];
